<template>
  <div id="app">
    <component :is="currentLayout">{{currentLayout}}</component>
    <snack-bars v-if="snackbarNotifications"></snack-bars>
    <terms-and-conditions-modal v-if="!isImpersonatingUser && !isSuperAdmin && user.id"></terms-and-conditions-modal>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { COMPANIES_WITH_SPECIFIC_FEATURES } from '@/modules/transactions/_constants/constants'
import LayoutDashboard from '@/layouts/LayoutDashboard.vue'
import LayoutBlank from '@/layouts/LayoutBlank.vue'
import SnackBars from '@/components/SnackBars/SnackBar'
import { segmentIdentify, segmentGroup } from '@/analytics/segment'
import { setLanguage } from '@/locales/'
import TermsAndConditionsModal from '@/components/TermsAndConditionsModal/TermsAndConditionsModal'
export default {
  computed: {
    currentLayout () {
      if (this.$route.meta.layout === 'blank' || this.$route.path === '/') {
        return 'layout-blank'
      } else {
        return 'layout-dashboard'
      }

      // if (this.$route.meta.isPublic || this.$route.path === '/') {
      //   return 'layout-blank'
      // } else {
      //   return 'layout-dashboard'
      // }
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    user () {
      return this.$store.getters['LoginStore/user']
    },
    snackbarNotifications () {
      return this.$store.getters['SnackBars/items'].length
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    isImpersonatingUser () {
      return this.$store.getters['LoginStore/isImpersonating']
    },
    languageQuery () {
      return this.$route.query?.lang || false
    },
    userLocale () {
      return this.$store.getters['UsersStore/userLocale']
    }
  },
  components: {
    'layout-dashboard': LayoutDashboard,
    'layout-blank': LayoutBlank,
    SnackBars,
    TermsAndConditionsModal
  },
  methods: {
    // Detects when token has been removed, forcing to login
    onTokenChange (event) {
      if (event.key === 'token' && !localStorage.getItem('token')) {
        Sentry.setUser(null)
        this.$router.push('/signin').catch(err => {
          throw err
        })
      }
    },
    _initializeLanguage () {
      if (this.userLocale) {
        setLanguage(this.userLocale)
        return
      }
      if (this.languageQuery) {
        setLanguage(this.languageQuery)
        return
      }
      if ('lang' in localStorage) {
        const lang = localStorage.getItem('lang')
        setLanguage(lang)
        return
      }
      const defaultLang = navigator.language.substring(0, 2)
      setLanguage(defaultLang)
    }
  },
  mounted () {
    window.addEventListener('storage', this.onTokenChange)
    if (this.user.id && !this.$route.meta.isPublic && this.$route.path !== '/') {
      const userTraits = {
        user_id: this.user.id,
        username: this.user.firstName,
        email: this.user.email,
        signup_source: 'web',
        user_role: this.user.roles.join(',')
      }

      segmentIdentify(this.user.id, userTraits)

      const groupTraits = {
        id: this.user.customer_id,
        customer_name: this.user.customer_name,
        signup_source: 'web',
        customer_typology: 'empresa'
      }

      segmentGroup(this.user.customer_id, groupTraits)
    }
  },
  created () {
    this._initializeLanguage()
    const { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
    if ((this.user.isOwnerOfAnyBudget || this.user.isReviewer) && this.isUser && this.user.office_id === id) {
      this.$router.replace('/reimbursements/pending/users')
    }
  },
  watch: {
    languageQuery: function (newV, oldV) {
      if (newV) {
        setLanguage(this.languageQuery)
      }
    }

  }
}
</script>

<style lang="scss">
@import "./assets/styles/styles.scss";
@import "./assets/styles/custom-styles.scss";
@import "./assets/styles/ui.scss";
@import "./assets/styles/helpers.scss";
@import "./assets/styles/inter-ui.css";
</style>
